import React from "react";
import { motion } from "framer-motion";
import content from "../content/content.json";

const columnVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};

const Industries = () => {
  const { industriesMenu } = content;

  return (
    <motion.div
      className="absolute top-full h-screen left-0 w-full bg-white shadow-lg z-50 py-12"
      initial="hidden"
      animate="visible"
      exit="hidden"
    >
      <div className="grid md:grid-cols-3 h-full">
        <motion.div className="bg-gray-300 p-8 h-full flex flex-col" custom={0} variants={columnVariants}>
          <h3 className="font-semibold text-3xl mb-6 text-[#1C1F2B]">{industriesMenu.title}</h3>
          <p className="text-sm text-[#1C1F2B] leading-loose">{industriesMenu.description}</p>
        </motion.div>

        <motion.div className="bg-gray-100 p-8 h-full" custom={1} variants={columnVariants}>
          <ol className="space-y-3 text-lg text-gray-700">
            {industriesMenu.columnOne.map((item) => (
              <li key={item} className="hover:text-[#D00] cursor-pointer">
                {item}
              </li>
            ))}
          </ol>
        </motion.div>

        <motion.div className="bg-gray-50 p-8 h-full" custom={2} variants={columnVariants}>
          <ol className="space-y-3 text-lg text-gray-700">
            {industriesMenu.columnTwo.map((item) => (
              <li key={item} className="hover:text-[#D00] cursor-pointer">
                {item}
              </li>
            ))}
          </ol>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Industries;

